import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=96464613
const initialState: {
  order_id?: string
  client_id?: string
  out_order_id?: string
} = {}
export const PayPal_get_ext_info = createAsyncThunk(
  '/live/pay/paypal_get_ext_info',
  async (order_id: string, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/paypal_get_ext_info',
      {
        ...store.getState().env.deviceinfo,
        order_id,
      }
    )
    return resp.data.data
  }
)

export const paypal_capture_order = createAsyncThunk(
  '/live/pay/paypal_capture_order',
  async (order_id: string, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/paypal_capture_order',
      {
        ...store.getState().env.deviceinfo,
        order_id,
      }
    )
    return resp.data.data
  }
)

export const Wallet2PayPalSlice = createSlice({
  name: 'Animal_Pangolin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(PayPal_get_ext_info.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
        order_id: action.meta.arg,
      })
    })
  },
})
export const Wallet2PayPalSliceActions = Wallet2PayPalSlice.actions
export default Wallet2PayPalSlice.reducer
export const useWallet2PayPalState = () => {
  const data = useSelector((state) => state.Animal_Pangolin)
  return data
}
